import { decodeJwt as decode, JWTPayload } from 'jose';

interface DecodedJwt extends JWTPayload {
  user_id: number;
  username: string;
  email: string;
  yozmit_onboarding_status: string;
  yozmit_profile_id: number;
  is_staff: boolean;
}

export const decodeJwt = (token: string): DecodedJwt | null => {
  try {
    const payload = decode(token) as DecodedJwt;

    return payload;
  } catch (error) {
    return null;
  }
};
